import { SettingsService } from "./settings.service";
import { videoUrl } from "./components/video-url/video-url.module";
import { settingsEdit } from "./settings-edit/settings-edit.module";
import { newsletter } from "./components/newsletter/newsletter.module";
import { settingsDetail } from "./settings-detail/settings-detail.module";
import { autoEmailNotificationUrl } from "./components/auto-email-notifications/auto-email-notifications.module";
import "./settings.scss";

export const settings = angular
  .module("components.settings", [
    settingsDetail,
    settingsEdit,
    videoUrl,
    newsletter,
    autoEmailNotificationUrl,
  ])
  .service("SettingsService", SettingsService).name;



// WEBPACK FOOTER //
// ./src/app/components/settings/settings.module.js